module.exports = __webpack_public_path__ + "static/media/pastorFamily2.429486b4.jpeg";